export enum ScaleStopBits {
  ONE_STOP_BIT = "1",
  ONE_POINT_FIVE_STOP_BITS = "1.5",
  TWO_STOP_BITS = "2"
}
